// 开发环境
const developUrl = "http://www.58ln.cn:81";
// const developUrl = "http://ceshi.58ln.cn:81";

// 测试环境
const testUrl = "http://ceshi.58ln.cn:81";

// 正式（线上）环境
// const formalUrl = "http://bkshequ.com:81";
const formalUrl = "http://bkshequ.58ln.cn:81";

let baseUrl;
let localHref = window.location.href;

if (localHref.includes('localhost') || localHref.includes('www.58ln.cn')) {
  baseUrl = developUrl;
} else if (localHref.includes('wechat.shequzaixian.cn') || localHref.includes('bkshequ.com')||localHref.includes('bkshequ.58ln.cn')) {
  baseUrl = formalUrl;
} else if (localHref.includes('ceshi.58ln.cn')) {
  baseUrl = testUrl;
} else {
  baseUrl = developUrl;
}
export default baseUrl;
